
const capitalize = (str) => {
    return str.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })
};

const replaceUnderscore = (str) => {
    return str.replace(/_/, '/');
};

const parseObjectTypeName = (str) => {
    return capitalize(replaceUnderscore(str))
};

export default parseObjectTypeName;


// WEBPACK FOOTER //
// ./src/js/helpers/parseObjectTypeName.js